module.exports = __webpack_public_path__ + "d982c94cb2768372883ade1bd3c1e3ea.png";